import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './main.css'

// Create and configure the Vue app
const app = createApp(App);

// Use router
app.use(router);

// Simple error handler for production
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue application error:', err);
  console.error('Component info:', info);
};

// Simple warning handler
app.config.warnHandler = (msg, vm, trace) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn('Vue Warning:', msg);
  }
};

// Mount the app
app.mount('#app');